// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mk9O2","productName":"Table_productName__nJjMf"};